export default __webpack_public_path__ + "static/media/feature1-1.08357d19.png";